import { useState, useRef } from "react";
import { cn } from "../lib/utils";

type TooltipSide = "top" | "bottom" | "left" | "right";

interface TooltipProps {
  content: React.ReactNode;
  side?: TooltipSide;
  children: React.ReactNode;
  className?: string;
  delay?: number;
  disabled?: boolean;
}

export function Tooltip({ content, side = "top", children, className, delay = 120, disabled = false }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = () => {
    if (disabled) return;
    timerRef.current = setTimeout(() => setVisible(true), delay);
  };
  const hide = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(false);
  };

  return (
    <span
      className={cn("tooltip-root", className)}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {visible && (
        <span className={cn("tooltip", `tooltip-${side}`)} role="tooltip">
          {content}
          <span className={cn("tooltip-arrow", `tooltip-arrow-${side}`)} />
        </span>
      )}
    </span>
  );
}
